module.exports = __webpack_public_path__ + "icons/original/large/large-a6.4ac50d73cecffe7683129cb537280e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a6.png
// module id = N7YA
// module chunks = app